import React from 'react';
import { LocalizationService } from 'app/services/localization';
import { LocalizationProvider, I18n } from 'app/components/localization';
import { DisplayLanguageProvider } from 'app/components/LanguageContext';
import { getLanguageById, isLanguageId } from 'app/constants/enums/Language';

const LocaleWrapper: React.SFC<{
  localizationService: LocalizationService,
}> = ({ children, localizationService }) => (
  <LocalizationProvider service={localizationService}>
    <I18n>{({ locale }) => {
      if (!isLanguageId(locale)) {
        throw new Error(`Expected locale to be a LanguageId, given: ${locale}`);
      }
      return (
        <DisplayLanguageProvider language={getLanguageById(locale)}>
          {children}
        </DisplayLanguageProvider>
      );
    }}</I18n>
  </LocalizationProvider>
);

export default LocaleWrapper;
